import React from 'react';
import { usePartnerLogoUrl } from '../../lib/partner-logo';

interface PartnerLogoProps {
    height?: number;
    className?: string;
}

export const PartnerLogo: React.FC<PartnerLogoProps> = ({ height, className }) => {
    const url = usePartnerLogoUrl();

    if (!url) return null;

    return <img src={url} className={className} style={height ? { maxHeight: `${height}px` } : undefined} alt="SK" />;
};
